import {
    ChangeDetectionStrategy,
    ChangeDetectorRef,
    Component,
    Input,
    OnDestroy,
    OnInit,
} from '@angular/core';
import {
    AbstractControl,
    FormGroup,
} from '@angular/forms';

import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Component({
    selector: 'ui-value-secondary-hints',
    templateUrl: './ui-value-secondary-hints.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class UiValueSecondaryHintsComponent implements OnInit, OnDestroy {
    @Input()
    public form!: FormGroup;
    @Input()
    public name!: string;

    public control!: AbstractControl;

    private _destroyed$ = new Subject();

    constructor(private _cd: ChangeDetectorRef) { }

    ngOnInit() {
        this.control = this.form.get(this.name)!;

        this.control.statusChanges
            .pipe(takeUntil(this._destroyed$))
            .subscribe(() => this._cd.markForCheck());
    }

    ngOnDestroy() {
        this._destroyed$.next();
    }
}
